import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { AdIntelligenceDescription } from "../../types/description.dto";
import type { IAdSpendVolumeFilterDto } from "../../types/leadsSearchFilters.dto";

export type AdSpendVolumeFilterOptions = AdIntelligenceDescription;

export default class FindAdSpendVolumeFilter extends FilterPanelBaseFilter<
    IAdSpendVolumeFilterDto,
    AdSpendVolumeFilterOptions
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IAdSpendVolumeFilterDto, AdSpendVolumeFilterOptions>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAdSpendVolumeFilterDto | undefined): boolean {
        const { channel: _initialChannel, ...initialWithoutChannel } = this.initialDtoValue ?? {};
        const { channel: _currentChannel, ...currentWithoutChannel } = currentValue ?? {};

        return JSON.stringify(initialWithoutChannel) !== JSON.stringify(currentWithoutChannel);
    }

    calculateValueDelta(
        previousValue: IAdSpendVolumeFilterDto | undefined,
        newValue: IAdSpendVolumeFilterDto | undefined,
    ): FilterValueDelta<IAdSpendVolumeFilterDto> {
        return calculateObjectValueDelta<Partial<IAdSpendVolumeFilterDto>>(previousValue, newValue);
    }
}
